import {BehaviorSubject} from 'rxjs';
import {callApi, callEmptyParamsApi} from "../connection/ClientApi";
import Urls from "../connection/Urls";
import {authenticationViewModel} from "./Authentication.viewModel";

const cartChangeSubject = new BehaviorSubject()
const productSubject = new BehaviorSubject()
const basketCountSubject = new BehaviorSubject()
const rewardSubject = new BehaviorSubject()

export const ACTIONS_TYPES = {
    ADD: 0,
    PLUS: 1,
    REMOVE: 2,
    DELETE: 3,
    SET: 4
}

export const basketViewModel = {
    clearCart,
    clearLocalCart,
    getCart,
    getCartChangeset,
    getProductInfoFromLocalBasket,
    getCartSetting,
    getTicketSubject,
    getDeliveryTimes,
    checkLocalBasket,
    addToBasket,
    plusToBasket,
    setQuantityToBasket,
    removeFromBasket,
    deleteFromBasket,
    getBasketCount,
    sendLocalDataToServer,
    getLocalBasket,
    cartChange: cartChangeSubject.asObservable(),
    product: productSubject.asObservable(),
    basketCount: basketCountSubject.asObservable(),
    reward: rewardSubject.asObservable()
};

function addToBasket(product, onSuccess, onFailure, onStart, onEnd) {
    runAction(product, -1, ACTIONS_TYPES.ADD, onSuccess, onFailure, onStart, onEnd)
}

function plusToBasket(product, onSuccess, onFailure, onStart, onEnd) {
    runAction(product, -1, ACTIONS_TYPES.PLUS, onSuccess, onFailure, onStart, onEnd)
}

function setQuantityToBasket(product, quantity, onSuccess, onFailure, onStart, onEnd) {
    runAction(product, parseInt(quantity), ACTIONS_TYPES.SET, onSuccess, onFailure, onStart, onEnd)
}

function removeFromBasket(product, onSuccess, onFailure, onStart, onEnd) {
    runAction(product, -1, ACTIONS_TYPES.REMOVE, onSuccess, onFailure, onStart, onEnd)
}

function deleteFromBasket(product, onSuccess, onFailure, onStart, onEnd) {
    runAction(product, -1, ACTIONS_TYPES.DELETE, onSuccess, onFailure, onStart, onEnd)
}

function runAction(product, quantity, actionType, onSuccess, onFailure, onStart, onEnd) {
    if (authenticationViewModel.isLogin) {
        let params = new FormData()
        params.append("product_id", product.product_id)

        if (quantity >= 0) {
            let paramQuantity = 0
            if (quantity > parseInt(product.basket_count)) {
                paramQuantity = quantity - parseInt(product.basket_count)
            } else if (quantity < parseInt(product.basket_count)) {
                paramQuantity = parseInt(product.basket_count) - quantity
            }
            params.append("quantity", paramQuantity)
        }

        let url
        if (actionType === ACTIONS_TYPES.ADD || actionType === ACTIONS_TYPES.PLUS) {
            url = Urls.addToBasket
        } else if (actionType === ACTIONS_TYPES.DELETE) {
            url = Urls.deleteFromBasket
        } else if (actionType === ACTIONS_TYPES.REMOVE) {
            url = Urls.removeFromBasket
        } else if (actionType === ACTIONS_TYPES.SET) {
            if (quantity > parseInt(product.basket_count)) {
                url = Urls.addToBasket
            } else if (quantity < parseInt(product.basket_count)) {
                url = Urls.removeFromBasket
            }
        }

        callApi(url, params, () => {
            manageBasketAfterAction(product, quantity, actionType)
            if (onSuccess) {
                onSuccess()
            }
        }, onFailure, onStart, onEnd)
    } else {
        callUnauthorizedProduct(() => {
            manageBasketAfterAction(product, quantity, actionType)
            if (onSuccess) {
                onSuccess()
            }
        }, onStart, onEnd)
    }
}

function callUnauthorizedProduct(onSuccess, onStart, onEnd) {
    callEmptyParamsApi(Urls.getUnauthorizedProduct, () => {
        onSuccess()
    }, () => {
        onSuccess()
    }, onStart, onEnd)
}

function manageBasketAfterAction(product, quantity, actionType) {
    let localBasket = getLocalBasket()
    if (actionType === ACTIONS_TYPES.ADD) {
        product.basket_count = 1
        product.basket_added = true
        localBasket.push(product)
        localStorage.setItem('basket', JSON.stringify(localBasket))
    } else {
        let index = localBasket.findIndex((element) =>
            element.product_id === product.product_id
        )
        if (index >= 0) {
            if (actionType === ACTIONS_TYPES.SET) {
                product.basket_count = quantity
                localBasket[index] = product

                localStorage.setItem('basket', JSON.stringify(localBasket))

                cartChangeSubject.next(true)
            } else if (actionType === ACTIONS_TYPES.PLUS) {
                product.basket_count = parseInt(product.basket_count) + 1
                localBasket[index] = product

                localStorage.setItem('basket', JSON.stringify(localBasket))

                cartChangeSubject.next(true)
            } else if (actionType === ACTIONS_TYPES.REMOVE) {
                if (parseInt(product.basket_count) - 1 <= 0) {
                    product.basket_count = 0
                    product.basket_added = false
                    localBasket = getLocalBasket().filter((item) =>
                        item.product_id !== product.product_id
                    )

                    localStorage.setItem('basket', JSON.stringify(localBasket))

                } else {
                    product.basket_count = parseInt(product.basket_count) - 1
                    localBasket[index] = product

                    localStorage.setItem('basket', JSON.stringify(localBasket))
                }

                cartChangeSubject.next(true)
            } else if (actionType === ACTIONS_TYPES.DELETE) {
                product.basket_count = 0
                product.basket_added = false
                localBasket = getLocalBasket().filter((item) =>
                    item.product_id !== product.product_id
                )

                localStorage.setItem('basket', JSON.stringify(localBasket))

                cartChangeSubject.next(true)
            }
        }
    }

    productSubject.next(product)
    basketCountSubject.next(localBasket.length.toString())

}

function getProductInfoFromLocalBasket(product) {
    let localBasket = getLocalBasket()

    let index = localBasket.findIndex((element) =>
        element.product_id === product.product_id
    )
    if (index >= 0) {
        product.basket_added = localBasket[index].basket_added
        product.basket_count = localBasket[index].basket_count
    }
    if (!product.image) {
        product.image = (product.images && product.images.length > 0) ? product.images[0] : ""
    }
    return product
}

function getLocalBasket() {
    let localBasketString = localStorage.getItem('basket')
    if (!localBasketString || localBasketString.trim() === '') {
        return []
    }
    return JSON.parse(localBasketString)
}

function checkLocalBasket(products) {
    for (let i = 0; i < products.length; i++) {
        if (!products[i].image) {
            products[i].image = (products[i].images && products[i].images.length > 0) ? products[i].images[0] : ""
        }
    }

    if (!authenticationViewModel.isLogin) {
        let localBasket = basketViewModel.getLocalBasket()
        for (let i = 0; i < products.length; i++) {
            let index = localBasket.findIndex((element) =>
                element.product_id === products[i].product_id
            )
            if (index >= 0) {
                products[i].basket_count = localBasket[index].basket_count
                products[i].basket_added = products[i].basket_count > 0
            }
        }
    }
    return products
}

function getBasketCount() {
    if (authenticationViewModel.isLogin) {
        callEmptyParamsApi(Urls.getCartAndRewardsSetting, (data) => {
            if (data.cart_products_count === "0") {
                localStorage.setItem('basket', JSON.stringify([]))
                basketCountSubject.next("0")
            } else {
                basketCountSubject.next(data.cart_products_count.toString())
            }
            rewardSubject.next({
                hasUnusedRewards: data.has_unused_rewards,
                unusedRewardsCount: data.unused_rewards_count
            })
        })
    } else {
        basketCountSubject.next(getLocalBasket().length.toString())
    }
}

function sendLocalDataToServer(onSuccess, onFailure, onStart, onEnd) {
    let localBasket = getLocalBasket()
    if (localBasket && localBasket.length > 0) {
        let basketString = ""
        for (const item of localBasket) {
            if (basketString.length > 0) {
                basketString += "#"
            }
            basketString += item.product_id + "," + item.basket_count
        }
        let params = new FormData()
        params.append("basket_products", basketString.toString())
        callApi(Urls.addAllToCart, params, onSuccess, onFailure, onStart, onEnd)
    } else {
        if (onSuccess) {
            onSuccess()
        }
    }
}

function getCart(onSuccess, onFailure, onStart, onEnd) {
    if (authenticationViewModel.isLogin) {
        callEmptyParamsApi(Urls.getCartWithChangesSet, (data) => {
            localStorage.setItem('basket', JSON.stringify(data.products))
            if (onSuccess) {
                onSuccess(data)
            }
            getBasketCount()
        }, () => {
            if (onFailure) {
                onFailure()
            }
        }, onStart, onEnd)
    } else {
        let total = 0
        let special = 0
        let products = getLocalBasket()
        for (const product of products) {
            if (product.price_price) {
                total = (total + (product.price_price * product.basket_count))
                if (product.special_price > 0) {
                    special = (special + ((product.price_price - product.special_price)
                            * product.basket_count)
                    )
                }
            } else {
                total = (total + (product.price * product.basket_count))
                if (product.special > 0) {
                    special = (special + ((product.price - product.special)
                            * product.basket_count)
                    )
                }
            }
        }
        if (onSuccess) {
            onSuccess({
                products: products,
                total: total,
                products_discount: special,
                net_total: total - special,
                reward_discount: 0,
                transportation_cost: 0
            })
        }
    }
}

function getCartChangeset(discountCode, useWallet, onSuccess, onFailure, onStart, onEnd) {
    let params = new FormData()
    if (discountCode) {
        params.append("reward_codes", discountCode)
    }
    params.append("use_wallet", useWallet)
    callApi(Urls.getCart, params, onSuccess, onFailure, onStart, onEnd)
}

function getCartSetting(onSuccess, onFailure, onStart, onEnd) {
    callEmptyParamsApi(Urls.getCartSetting, onSuccess, onFailure, onStart, onEnd)
}

function getTicketSubject(onSuccess, onFailure, onStart, onEnd) {
    callEmptyParamsApi(Urls.getTicketSubject, onSuccess, onFailure, onStart, onEnd)
}

function getDeliveryTimes(dateValue, onSuccess, onFailure, onStart, onEnd) {
    let params = new FormData()
    params.append("selectMiladiDate", dateValue)
    callApi(Urls.getDeliveryTimes, params, onSuccess, onFailure, onStart, onEnd)
}

function clearCart(onSuccess, onFailure, onStart, onEnd) {
    if (authenticationViewModel.isLogin) {
        callEmptyParamsApi(Urls.deleteAllCart, () => {
            clearLocalCart(onSuccess)
        }, () => {
            if (onFailure) {
                onFailure()
            }
        }, onStart, onEnd)
    } else {
        clearLocalCart(onSuccess)
    }
}

function clearLocalCart(onSuccess) {
    localStorage.setItem('basket', JSON.stringify([]))
    cartChangeSubject.next(true)
    basketCountSubject.next("0")
    if (onSuccess) {
        onSuccess()
    }
}